<template>
    <Popup
        style="background: transparent"
        :value="value"
        :close-on-click-overlay="false">
        <div class="box">
            <div class="box-head van-hairline--bottom">请选择您所持有的证书版本</div>
            <div class="box-list">
                <div class="box-item van-hairline--bottom" @click="switchPaper">
                    <div class="item_left">
                        <img v-if="paperVersion" src="./img/icon_yellow.png" alt="">
                        <img v-else src="./img/icon_gray.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right-title">纸质版</div>
                        <div class="right-desc">可拍照上传纸质证书选择此项</div>
                    </div>
                </div>
                <div class="box-item"  @click="switchElectron">
                    <div class="item_left">
                        <img v-if="electronVersion" src="./img/icon_yellow.png" alt="">
                        <img v-else src="./img/icon_gray.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right-title">电子版</div>
                        <div class="right-desc">持有【护士电子信息化系统】网站详情页</div>
                    </div>
                </div>
            </div>

            <div class="box-bottom">
                <VanButton @click="submit" class="bot_btn" size="large" round>确定</VanButton>
            </div>
        </div>
    </Popup>
</template>

<script>
    import {Popup, Button as VanButton, Toast} from 'vant';

    export default {
        name: 'CertificateVersion',
        props: {
            value: Boolean,
        },
        data() {
            return {
                certType: 'paper', // paper 纸质 electron 电子
                paperVersion: true,
                electronVersion: false,
            }
        },
        methods: {
            switchPaper() {
                this.electronVersion = false;
                this.paperVersion = !this.paperVersion;
            },
            switchElectron() {
                this.paperVersion = false;
                this.electronVersion = !this.electronVersion;
            },
            submit() {
                if (this.paperVersion) {
                    this.$emit('dialogs', 'paper')
                } else if (this.electronVersion) {
                    this.$emit('dialogs', 'electron')
                } else {
                    Toast('请选择证书版本');
                }
            },
        },
        components: {Popup, VanButton, Toast}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .box {
        width: 295px;
        background: #FFFFFF;
        border-radius: 5px;
        overflow: hidden;
        &-head {
            display: flex;
            align-items: center;
            justify-content: center;
            height:60px;
            font-size:19px;
            font-weight:500;
            color:rgba(34,34,34,1);
            background:rgba(252,252,252,1);
        }

        .box-list {
            background: #ffffff;
            padding-left: 13px;
            .box-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 66px;
                .item_left {
                    flex-shrink: 0;
                    width: 34px;
                    display: inline-flex;
                    justify-content: center;
                    img {
                        display: inline-block;
                        width: 19px;
                        height: 19px;
                    }
                }
                .item_right {
                    flex: 1;
                    padding-left: 5px;
                    .right-title {
                        font-size:17px;
                        font-weight:500;
                        color:rgba(34,34,34,1);
                    }
                    .right-desc {
                        font-size:12px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        margin-top: 8px;
                    }
                }
            }
        }

        &-bottom {
            padding: 10px 17px 23px;
            .bot_btn {
                height: 40px;
                line-height: 38px;
                background: #FFC600;
                &>span {
                    font-size:16px;
                    font-weight:400;
                    color:rgba(43,21,0,1);
                }
            }

        }
    }
</style>
